var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdditionalHearthSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.55207e-08 11.6899H13.0097L13.0097 9.72309L6.86909 4.42188H6.14056L2.77859e-07 9.72309L4.55207e-08 11.6899Z",
    fill: "#040626"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.54993 4.422L10.4598 4.422L10.4598 3.22369L6.72606 -2.77107e-05L6.2837 -2.77494e-05L2.54994 3.22369L2.54993 4.422Z",
    fill: "#040626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdditionalHearthSymbol);
export default __webpack_public_path__ + "static/media/additional_hearth_symbol.9ffad509d04ba143bf067219b3c6f3cf.svg";
export { ForwardRef as ReactComponent };